import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { useLogger } from "@/utils/loggerService";
import { Navigate, useLocation, useOutlet } from "react-router";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import { useParams } from "react-router-dom";
/**
 * Route guard
 */
export default function (_a) {
    var children = _a.children;
    var token = useAppSelector(function (state) { return state.auth.token; });
    var outlet = useOutlet();
    var location = useLocation();
    var _b = useParams(), module = _b.module, action = _b.action;
    var logger = useLogger().logger;
    var lastUrl = sessionStorage.getItem("lastVisitedUrl") || "/";
    var publicRoutes = ["/login", "/resetPassword"];
    var isPublicRoute = publicRoutes.some(function (route) {
        return location.pathname.startsWith(route);
    });
    var currentUser = useAppSelector(getCurrentUser);
    var user = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes;
    // Check token
    //if (!token && location.pathname !== "/login") {
    if (!token && !isPublicRoute) {
        logger.debug("No session, redirect to login", location.pathname);
        return _jsx(Navigate, { to: "/login" });
    }
    // Has token, redirect to home or any other URL (previous ?)
    if (token && location.pathname === "/login") {
        var safeLastUrl = lastUrl.includes("resetPassword") ? "/" : lastUrl;
        logger.debug("Already has session, redirect to safe URL", safeLastUrl);
        return _jsx(Navigate, { to: safeLastUrl, replace: true });
    }
    /**
     * SECURITY:
     * Standard user can only access own profile
     */
    if (token && user && user.is_admin !== "1") {
        var isUsersModule = location.pathname.startsWith("/modules/Users");
        var safeAction = action !== null && action !== void 0 ? action : "detailView";
        if (isUsersModule) {
            var myProfileUrl = "/modules/Users/".concat(safeAction, "/").concat(user.id);
            /**
             * Redirect any Users URL
             * to current user profile
             */
            if (location.pathname !== myProfileUrl) {
                logger.debug("Redirect standard user to own profile", myProfileUrl);
                return _jsx(Navigate, { to: myProfileUrl, replace: true });
            }
        }
    }
    if (!outlet) {
        return children;
    }
    return _jsx(_Fragment, { children: outlet });
}
